export default "query getDettagliLatitudini ($params: DettaglioLatitudiniParams!) {\n    getDettagliLatitudini(params: $params)\n}";